import React from 'react'
import { getLocalApiUrl, authFetch } from '../config/api'

function initials(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean)
  return ((parts[0]?.[0] || '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase() || '?'
}

/**
 * Employee photo. The image endpoint needs auth, so it is fetched as a blob.
 * Shows initials when the employee has no photo. onLoaded(source) reports 'manual' | 'kyc' | null.
 */
export default function StaffPhoto({ staffId, name, size = 56, reloadKey = 0, onLoaded }) {
  const [src, setSrc] = React.useState(null)

  React.useEffect(() => {
    if (!staffId) return undefined
    let url = null
    let cancelled = false
    ;(async () => {
      try {
        const res = await authFetch(getLocalApiUrl(`/api/staff/${staffId}/photo`))
        if (!res.ok) throw new Error('none')
        const source = res.headers.get('X-Photo-Source')
        url = URL.createObjectURL(await res.blob())
        if (!cancelled) { setSrc(url); onLoaded?.(source || 'manual') }
      } catch {
        if (!cancelled) { setSrc(null); onLoaded?.(null) }
      }
    })()
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url) }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staffId, reloadKey])

  const style = { width: size, height: size }
  return src ? (
    <img src={src} alt={name || 'Employee'} style={style} className="rounded-full object-cover border border-gray-200 shrink-0" />
  ) : (
    <div style={{ ...style, fontSize: Math.round(size / 2.8) }} className="rounded-full bg-gray-200 text-gray-600 font-semibold flex items-center justify-center shrink-0">
      {initials(name)}
    </div>
  )
}
